// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
const Vue = require('vue')
import App from './App'
import store from './store'
import router from './router'
import promise from 'es6-promise'

import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog' // error log
import './asyncRouter' //

import * as filters from './utils/filters'

import vuescroll from 'vuescroll/dist/vuescroll-native'
import 'vuescroll/dist/vuescroll.css'

// ant-design
import Antd from '../node_modules/ant-design-vue'
import '../node_modules/ant-design-vue/dist/antd.less'
import { initBuryPoint } from './utils/buryPoint'
Vue.use(Antd)

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const IwaysUi = require('IwaysUi')
Vue.use(IwaysUi)

promise.polyfill()
Vue.use(vuescroll)
Vue.config.productionTip = false
initBuryPoint() // 注册埋点
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js